module.exports = __webpack_public_path__ + "img/metaMaskInstallationStep_17_mobile.201a3bb.png";